import React from "react";
import "./footer.css";

const Footer = () => {
  return (
    <footer>
      <p className="footer__logo">
        Paul
      </p>
      
      <div className="footer__copyright">
        <small>&copy; Paul K. All rights reserved</small>
      </div>
    </footer>
  );
};

export default Footer;
